import type { SimpleVehicleProps } from '../../../types/types'
import { CarParkOverviewCard } from './CarParkOverviewCard'
import type { FleetSummary } from '../../../../../../../types'
import type { FleetFilter } from '../../../../../../../hooks/useFleet'
import { hasDeviationsOrWarnings } from '../../../helpers/hasDeviationsOrWarnings'

const FILTER_CARDS: { filter: FleetFilter; title: string; count: (summary?: FleetSummary | null) => number }[] = [
  { filter: 'all', title: 'Alle biler', count: (summary) => summary?.totalCount ?? 0 },
  { filter: 'order', title: 'I bestilling', count: (summary) => summary?.orderedCount ?? 0 },
  { filter: 'active', title: 'Aktive biler', count: (summary) => summary?.activeCount ?? 0 },
  { filter: 'expiring', title: 'Utgående biler', count: (summary) => summary?.expiringCount ?? 0 },
  { filter: 'closed', title: 'Avsluttede biler', count: (summary) => summary?.closedCount ?? 0 },
]

const CARDS_WITH_REST: FleetFilter[] = ['expiring', 'closed']

export function CarParkOverviewList({
  cars,
  summary,
  summaryLoading,
  filter,
  onFilterChange,
  showDeviations,
  onToggleDeviations,
  deviationsLoading,
}: {
  cars: SimpleVehicleProps[]
  summary?: FleetSummary | null
  summaryLoading?: boolean
  filter: FleetFilter
  onFilterChange: (filter: FleetFilter) => void
  showDeviations?: boolean
  onToggleDeviations?: () => void
  deviationsLoading?: boolean
}) {
  const carsWithDeviationsOrWarnings = cars.filter(hasDeviationsOrWarnings)

  const carsMissingKmReading = carsWithDeviationsOrWarnings.filter((car) =>
    car?.warnings?.some((d) => d.code === 'Km avlesing'),
  ).length

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6">
      {FILTER_CARDS.map((card) => (
        <CarParkOverviewCard
          key={card.filter}
          title={card.title}
          amount={card.count(summary)}
          {...(CARDS_WITH_REST.includes(card.filter) && { rest: summary?.totalCount })}
          isLoading={summaryLoading}
          isActive={filter === card.filter}
          setCarList={() => onFilterChange(card.filter)}
        />
      ))}
      <CarParkOverviewCard
        title="Avvik til behandling"
        amount={carsWithDeviationsOrWarnings.length}
        infoText="Klikk for å oppdatere"
        isActive={showDeviations}
        isLoading={deviationsLoading}
        setCarList={onToggleDeviations}
        {...(carsMissingKmReading > 0 && { description: `${carsMissingKmReading} av disse mangler kmstand` })}
        {...(filter !== 'all' && { hint: 'Trykk "Alle biler" for å se alle avvik' })}
      />
    </div>
  )
}
